import React from 'react';
import styles from '../styles.module.css';
import { useMediaQueryDown } from '../../../../hooks/useMediaQuery';
function HeaderDivider({ children, breakPoint = 'sm' }) {
  const isSmallScreen = useMediaQueryDown(breakPoint);
  return <div className={isSmallScreen ? styles.dividerMobile : styles.divider}>{children}</div>;
}

export default HeaderDivider;
